// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"1b6321706b58a2664445","293":"9cf695ccbce8ade79e06","518":"1ceb9330d6884986de29","779":"f516f9ec17ec2d06af49"}[chunkId] + ".js";
};